import { FC } from 'react'
import './credit-balance.css'

// COMPONENTS
import Switch from '@components/atoms/switch'

// UTILITIES
import { priceFormatter } from '@utils/number-helper'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
    creditAmount: number // in pennies
    isApplied: boolean
    onToggle: (checked: boolean) => void
}

const CreditBalance: FC<Props> = (props) => {
    const { className: classProps, creditAmount, isApplied, onToggle, ...divProps } = props
    
    const formattedAmount = priceFormatter.format(creditAmount / 100)
    
    function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
        onToggle(e.target.checked)
    }
    
    return (
        <div className={`credit-balance ${classProps || ''}`} {...divProps}>
            <div className="credit-balance-content">
                <div className="credit-balance-info">
                    <p className="credit-balance-title">Splitcard Credit</p>
                    <p className="credit-balance-description">Use your credits</p>
                </div>
            </div>
            <div className="credit-balance-amount-section">
                <p className="credit-balance-amount">{formattedAmount}</p>
                <p className="credit-balance-available">AVAILABLE</p>
            </div>
            <div className="credit-balance-toggle">
                <Switch
                    checked={isApplied}
                    onChange={handleChange}
                    className="credit-balance-switch"
                />
            </div>
        </div>
    )
}

export default CreditBalance
